





























































import { Component } from 'vue-property-decorator';
import '@/assets/scss/pages/page-auth.scss';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import UserStatusBadge from '@/components/common/UserStatusBadge.vue';

import { Edit2Icon, MoreVerticalIcon, PlusIcon } from 'vue-feather-icons';
import Avatar from '@/components/common/Avatar.vue';
import ProductStatusBadge from '@/components/common/ProductStatusBadge.vue';
import { IProduct } from 'admiral-core';
import { ProductApi } from '@/services/ProductApi';
import CreateProductModal from '@/views/pages/settings/product/CreateProductModal.vue';
import EditProductModal from '@/views/pages/settings/product/EditProductModal.vue';

@Component({
  name: 'agency-products-settings',
  components: {
    EditProductModal,
    CreateProductModal,
    ProductStatusBadge,
    Avatar,
    UserStatusBadge,
    MoreVerticalIcon,
    Edit2Icon,
    PlusIcon,
  },
})
class AgencyProductsSettings extends mixins(BaseMixin) {
  allProducts: IProduct[] = [];

  selectedProduct: IProduct | null = null;

  async mounted() {
    await this.reload();
  }

  async reload() {
    try {
      const response = await ProductApi.getProducts({
        agency: this.agency,
        showInactive: true,
      });

      this.allProducts = response.data;
    } catch (e) {
      console.log(e);
    }
  }

  async setInactive(product: IProduct) {
    try {
      product.isActive = false;
      await ProductApi.update(product.id, {
        isActive: product.isActive,
        agency: this.agency,
      });
      await this.$store.dispatch('DataModule/fetchProducts', {
        agency: this.user.agency,
      });
    } catch (e) {
      console.log(e);
    }
  }

  async setActive(product: IProduct) {
    try {
      product.isActive = true;
      await ProductApi.update(product.id, {
        isActive: product.isActive,
        agency: this.agency,
      });
      await this.$store.dispatch('DataModule/fetchProducts', {
        agency: this.user.agency,
      });
    } catch (e) {
      console.log(e);
    }
  }
  async openEditProductModal(product: IProduct) {
    this.selectedProduct = product;
    (this.$refs['edit-product-modal'] as any).$refs['edit-product'].show();
  }
}

export default AgencyProductsSettings;
